import React from 'react';
import Modal from '@/js/components/common/Modal';
import intransfer from '@/js/intransfer';
import bugsnag from '@/bugsnag-config';
import PropTypes from 'prop-types';

class TropicErrorBoundaryModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	componentDidCatch(error, info) {
		this.setState({ hasError: true });
		// bugsnag may rethrow errors in dev envs, resulting in duplicate error reports
		bugsnag.notifyException(error, { react: info });
	}
	render() {
		let footerFragment = (<button type="button" className="TropicErrorBoundaryGoBackToCompass btn btn-primary"
			onClick={() => intransfer.compass.toViewMeetings()}
		>
			Go back to Compass
		</button>);

		if (!this.state.hasError) return this.props.children;
		else return (
			<div className="TropicErrorBoundary">
				<Modal footer={footerFragment}>
					<p>Something went wrong, but we're not sure what it was. Please start over and try again.</p>
				</Modal>
			</div>
		);
	}
}

TropicErrorBoundaryModal.propTypes = {
	children: PropTypes.node.isRequired
};

export default TropicErrorBoundaryModal;
